import React from 'react'
import { DeleteIcon } from '@chakra-ui/icons'
import {
  HStack,
  VStack,
  Button,
  IconButton,
  Input,
  Textarea,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from '@chakra-ui/react'

import {
  Card,
  Form,
  FieldList,
  FieldListItem,
  FormField,
  FormFieldArray,
  FormFieldWatch,
  BooleanCheckbox
} from 'components'

import { useStageListQuery } from 'modules/stages'
import { QuestionTypeSelect } from 'modules/questions'
import { DimensionDataSelect } from 'modules/dimensions'

import { QuestionType } from '../enums'

export const QuestionEditForm = React.forwardRef(({ data, isLoading, onSubmit, ...props }, ref) => {
  const stageList = useStageListQuery()

  return (
    <Form ref={ref} data={data} isLoading={isLoading} onSubmit={onSubmit}>
      <VStack align='stretch'>
        <Card heading='Detalhes'>
          <FieldList>
            <FieldListItem isRequired label='Texto'>
              <FormField name='text'>
                <Textarea />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Texto (tempo verbal futuro)'>
              <FormField name='textFuture'>
                <Textarea />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Explicação'>
              <FormField name='description'>
                <Input type='text' />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Sugestão de leitura'>
              <FormField name='associatedLink'>
                <Input type='text' />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Dimensão'>
              <FormField name='dimension.id'>
                <DimensionDataSelect />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Tipo'>
              <FormField name='type'>
                <QuestionTypeSelect />
              </FormField>
            </FieldListItem>

            <FieldListItem isRequired label='Limiar'>
              <FormField name='threshold'>
                <Input type='number' />
              </FormField>
            </FieldListItem>

            <FieldListItem label='Permite N/A'>
              <FormField name='notApplicable' defaultValue={false}>
                <BooleanCheckbox />
              </FormField>
            </FieldListItem>
          </FieldList>
        </Card>

        <FormFieldWatch name='type'>
          {type =>
            type === QuestionType.MULTIPLE && (
              <Card heading='Opçōes de múltipla escolha'>
                <FormFieldArray name='options' keyName='key'>
                  {(options, { append, remove }) => (
                    <VStack align='stretch'>
                      {options.map((option, index) => (
                        <HStack key={option.id}>
                          <FormField
                            isRequired
                            defaultValue={option.value}
                            name={`options[${index}].value`}
                            render={<Input type='text' />}
                          />
                          <IconButton
                            variant='ghost'
                            colorScheme='red'
                            aria-label='Remover'
                            onClick={() => remove(index)}
                            icon={<DeleteIcon />}
                          />
                        </HStack>
                      ))}
                      <Button onClick={() => append({ value: '' })}>Adicionar opção</Button>
                    </VStack>
                  )}
                </FormFieldArray>
              </Card>
            )
          }
        </FormFieldWatch>

        <Card heading='Recomendações'>
          <Table caption='Recomendações'>
            <Thead>
              <Tr>
                <Th id='col_stage'>Fase</Th>
                <Th id='col_bellow'>Abaixo do limiar</Th>
                <Th id='col_above'>Acima do limiar</Th>
              </Tr>
            </Thead>
            <Tbody>
              {stageList.data?.map(({ id, name }, index) => (
                <Tr key={index}>
                  <Th id={`cell_stage_${index}`}>
                    {name}
                    <FormField
                      isRequired
                      defaultValue={id}
                      name={`recommendations[${index}].stage.id`}>
                      <input type='hidden' />
                    </FormField>
                  </Th>
                  <Td>
                    <FormField
                      isRequired
                      name={`recommendations[${index}].bellow`}
                      aria-labelledby={`cell_stage_${index} col_bellow`}>
                      <Input type='text' />
                    </FormField>
                  </Td>
                  <Td>
                    <FormField
                      isRequired
                      name={`recommendations[${index}].above`}
                      aria-labelledby={`cell_stage_${index} col_above`}>
                      <Input type='text' />
                    </FormField>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Card>
      </VStack>
    </Form>
  )
})

export default QuestionEditForm
